import { useState,useMemo  } from 'react';
import PropTypes from 'prop-types';

import "@esri/calcite-components/components/calcite-input";
import "@esri/calcite-components/components/calcite-list";
import "@esri/calcite-components/components/calcite-list-item";

import './ReservationsPanelSearch.css';

const ReservationsPanelSearch = ({
  allReservations,
  onSelect
}) => {
  const [search, setSearch] = useState('');
  const [dropdownOpen, setDropdownOpen] =
    useState(false);

  const matches = useMemo(() => {
    if (!search) {
      return [];
    }

    return allReservations
      .filter(
        (reservation) =>
          reservation.name &&
          reservation.name
            .toLowerCase()
            .includes(search.toLowerCase())
      )
      .slice(0, 5);
  }, [search, allReservations]);

  const handleInputChange = (event) => {
    const value =
      event.target?.value ??
      event.detail?.value ??
      '';

    setSearch(value);
    setDropdownOpen(!!value);

    console.log(
      'Input changed:',
      value
    );
  };

  const handleSelect = (reservation) => {
    console.log(
      'Selected reservation:',
      reservation
    );

    setSearch(reservation.name);
    setDropdownOpen(false);

    if (onSelect) {
      onSelect(reservation);
    }
  };

  return (
    <div className="search-reservation-component">
      <calcite-input
        placeholder="Search reservation by name..."
        value={search}
        oncalciteinputinput={handleInputChange}
        onFocus={() => {
          setDropdownOpen(!!search);

          console.log(
            'Input focused, dropdownOpen:',
            !!search
          );
        }}
        onBlur={() =>
          setTimeout(
            () => setDropdownOpen(false),
            150
          )
        }
        style={{ width: '100%' }}
        aria-label="Search reservation by name"
        role="searchbox"
      />

      {dropdownOpen && matches.length > 0 && (
        <div className="search-dropdown">
          <calcite-list
            role="list"
            aria-label="Search results"
          >
            {matches.map((reservation) => (
              <calcite-list-item
                key={reservation.id}
                label={reservation.name}
                description={
                  reservation.details || ''
                }
                onMouseDown={() =>
                  handleSelect(reservation)
                }
                className="search-dropdown-list-item"
                role="listitem"
                tabIndex={0}
                aria-label={`Select reservation ${reservation.name}`}
              />
            ))}
          </calcite-list>
        </div>
      )}
    </div>
  );
};

ReservationsPanelSearch.propTypes = {
  allReservations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
      name: PropTypes.string.isRequired,
      details: PropTypes.string,
    })
  ).isRequired,

  onSelect: PropTypes.func.isRequired,
};

export default ReservationsPanelSearch;